import { chain, groupBy, keys, map, uniqBy } from "lodash";
import CustomJsonError from "../CustomJsonError";
import { translateError } from "../localisation/localeUtil";
import { ErrorItem, ErrorItems } from "../types/Error";

// Helper to parse Axios error reponse
export const parseAxiosError = (error: CustomJsonError): string => {
  // return generic message
  if (!error) return "Unknown error occurred";
  if (typeof error === "string") return error;

  const message = error.message ?? error.errorMessage ?? "Error occurred";
  if (!error.info && !message) return "Error occurred";
  if (!error.info) return message ?? "Error occurred";
  if (!message) return "Error occurred";

  const errors: ErrorItem[] = error.info?.errors || [];
  if (!errors || errors.length === 0) return message;

  // Parse ErrorItems // add ErrorCode specific parse as required
  const groupedErrors = chain(error.info.errors)
    .groupBy("code")
    .mapValues((codeGroup) => groupBy(codeGroup, "message"))
    .value();

  // Extract unique messages
  const uniqueMessages = chain(groupedErrors)
    .flatMap((codeGroup) => keys(codeGroup))
    .filter(Boolean)
    .uniq()
    .value();

  // return original message if no parsed msgs
  if (uniqueMessages.length === 0) return message;

  return uniqueMessages.join("\r\n");
};

type CatchExceptionCallback = (error, selectedLanguage?: string) => [string, string];

// export const ErrorToast = ({ heading, body }: { heading?: string; body?: string }) => (
//   <div className="custom-error-toast d-flex align-items-start justify-content-start gap-2">
//     <CircleAlert size={18} className="toast-alert-icon" />

//     <div>
//       {heading && <div className="toast-heading">{heading}</div>}
//       {body && <div className="toast-body-text">{body}</div>}
//     </div>
//   </div>
// );

// helper to dispatch error toast for caught api errors
export const catchExceptionCallbackBody: CatchExceptionCallback = (error, selectedLanguage = "en") => {
  console.log("error", error);
  let errorBody = String(error);
  let errorHeading = "";

  const responseData = error?.response?.data;

  if (responseData) {
    const errors = responseData.info?.errors ?? [];

    const codes = keys(groupBy(errors, "code")) || [error.response.status];

    errorHeading = map(codes, (code) => translateError(code, selectedLanguage)).join("\n");

    const itemMessages = errors.map((e: { message?: string }) => `• ${e.message}`).join("\n");

    errorBody = [responseData.message, itemMessages].filter(Boolean).join("\n");

    // fallback to Axios error.
    if (!errorBody) {
      errorBody = parseAxiosError(error.response.data);
    }
  } else if (error?.message) {
    errorBody = error.message;
  }

  // toast.error(<ErrorToast heading={errorHeading} body={errorBody} />, {
  //   autoClose: 5000,
  //   closeButton: false,
  //   icon: false,
  //   position: "top-center",
  //   hideProgressBar: true,
  //   closeOnClick: true,
  //   pauseOnHover: false,
  //   className: "toast-error-shell",
  // });

  return [errorBody, errorHeading];
};

// helper to dispatch error toast for ErrorItems obj
export const errorItemsBody = (errorItems: ErrorItems, messageHeader?: string, selectedLanguage = "en"): string => {
  const errors = Object.values(errorItems);

  if (!errors.length) return "";

  const errorBody = uniqBy(errors, "message")
    .map((e) => `• ${e.message}`)
    .join("\n");

  return errorBody;

  // toast.error(<ErrorToast heading={messageHeader} body={errorBody} />, {
  //   autoClose: 5000,
  //   closeButton: false,
  //   icon: false,
  //   position: "top-center",
  //   hideProgressBar: true,
  //   closeOnClick: true,
  //   pauseOnHover: false,
  //   className: "toast-error-shell",
  // });
};

// export const Result = ({ children }) => <div className="result">{children}</div>;

// export const ErrorResult = ({ children }) => <div className="fv-help-block">{children}</div>;
